"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendApprovalNotification = void 0;
var collectionsRef_1 = require("common/db/collectionsRef");
var lodash_1 = require("lodash");
var getUsersWithAprrovalPermssions_1 = __importDefault(require("portal/utils/getUsersWithAprrovalPermssions"));
var getUsersWithWarehousePermission_1 = __importDefault(require("./getUsersWithWarehousePermission"));
function sendApprovalNotification(_a) {
    var approval = _a.approval, projectId = _a.projectId, amount = _a.amount, docType = _a.docType, docId = _a.docId, userId = _a.userId, ref = _a.ref, docDesc = _a.docDesc, action = _a.action, officeId = _a.officeId, warehouseId = _a.warehouseId, fromWarehouseId = _a.fromWarehouseId, toWarehouseId = _a.toWarehouseId, GIOId = _a.GIOId, SRId = _a.SRId, quantity = _a.quantity, DNId = _a.DNId;
    return __awaiter(this, void 0, void 0, function () {
        var uids, _b, _c, _d;
        var _this = this;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    uids = [];
                    _b = docType;
                    switch (_b) {
                        case 'DN': return [3 /*break*/, 1];
                        case 'GIO': return [3 /*break*/, 3];
                        case 'Sent-SR': return [3 /*break*/, 5];
                        case 'Receive-SR': return [3 /*break*/, 7];
                    }
                    return [3 /*break*/, 9];
                case 1: return [4 /*yield*/, (0, getUsersWithWarehousePermission_1.default)(approval, warehouseId)];
                case 2:
                    uids = _e.sent();
                    return [3 /*break*/, 11];
                case 3: return [4 /*yield*/, (0, getUsersWithWarehousePermission_1.default)(approval, fromWarehouseId)];
                case 4:
                    uids = _e.sent();
                    return [3 /*break*/, 11];
                case 5: return [4 /*yield*/, (0, getUsersWithWarehousePermission_1.default)(approval, fromWarehouseId)];
                case 6:
                    uids = _e.sent();
                    return [3 /*break*/, 11];
                case 7: return [4 /*yield*/, (0, getUsersWithWarehousePermission_1.default)(approval, toWarehouseId)];
                case 8:
                    uids = _e.sent();
                    return [3 /*break*/, 11];
                case 9: return [4 /*yield*/, (0, getUsersWithAprrovalPermssions_1.default)(approval, projectId, amount)];
                case 10:
                    uids = _e.sent();
                    return [3 /*break*/, 11];
                case 11:
                    _d = (_c = Promise).all;
                    return [4 /*yield*/, (0, lodash_1.uniq)(uids).map(function (uid) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, collectionsRef_1.notificationsRef.add({
                                            officeId: officeId == undefined || officeId == '' ? '' : officeId,
                                            warehouseId: warehouseId && warehouseId !== '' ? warehouseId : '',
                                            userId: uid,
                                            action: action,
                                            approval: approval,
                                            createdAt: new Date(),
                                            updatedAt: new Date(),
                                            projectId: projectId,
                                            docId: docId,
                                            docType: docType,
                                            byUserId: userId,
                                            approved: false,
                                            read: false,
                                            description: docDesc,
                                            content: {
                                                ref: ref,
                                            },
                                            toWarehouseId: toWarehouseId !== null && toWarehouseId !== void 0 ? toWarehouseId : '',
                                            fromWarehouseId: fromWarehouseId !== null && fromWarehouseId !== void 0 ? fromWarehouseId : '',
                                            GIOId: GIOId !== null && GIOId !== void 0 ? GIOId : '',
                                            SRId: SRId !== null && SRId !== void 0 ? SRId : '',
                                            DNId: DNId !== null && DNId !== void 0 ? DNId : " ",
                                            quantity: quantity !== null && quantity !== void 0 ? quantity : 0,
                                        })];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                case 12: return [4 /*yield*/, _d.apply(_c, [_e.sent()])];
                case 13:
                    _e.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.sendApprovalNotification = sendApprovalNotification;
